/* eslint-disable @typescript-eslint/no-empty-function */
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { InputItemType, getInputType } from './utils'

export type FiltersGroupProps = {
  items: InputItemType[]
  filtersCount?: number
  testId?: string
}

export const FiltersGroup = ({
  items,
  filtersCount,
  testId,
}: FiltersGroupProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <StyledWrapper data-testid={testId}>
      <StyledInputsWrapper
        data-testid={testId ? `${testId}-inputs` : undefined}
      >
        {items?.map((item) => getInputType(item))}
      </StyledInputsWrapper>
      {filtersCount && (
        <StylesCountWrapper
          data-testid={testId ? `${testId}-count` : undefined}
        >
          <Text>{`${filtersCount} ${t(
            generalConstants.FILTERS_APPLIED,
          )}`}</Text>
        </StylesCountWrapper>
      )}
    </StyledWrapper>
  )
}

const StyledInputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid;
  border-radius: 9px;
  border-color: ${(props) => props.theme.color.neutral.color7} !important;
  background-color: ${(props) => props.theme.color.neutral.color10} !important;
`

const StylesCountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color8} !important;
  color: ${(props) => props.theme.color.neutral.color5} !important;
  font-weight: 400;
  margin-top: 12px;
  padding-top: 6px;
`

export default FiltersGroup
